// Page arithmetic for the shared Pagination control. The server pages every
// list; these only describe the page the server sent.

export type PageItem = number | 'gap';

export const pageCount = (total: number, pageSize: number): number =>
  Math.max(1, Math.ceil(Math.max(0, total) / Math.max(1, pageSize)));

/** First and last row number on a page (1-based), or 0–0 for an empty list. */
export function shownRange(page: number, pageSize: number, total: number): { from: number; to: number } {
  if (total <= 0) return { from: 0, to: 0 };
  const from = Math.min(total, (page - 1) * pageSize + 1);
  return { from, to: Math.min(total, page * pageSize) };
}

/**
 * The page buttons to draw: the first and last page always, the current page
 * with `around` neighbours each side, and a gap where pages are left out. A
 * gap never stands for a single page — that page is shown instead.
 */
export function pageItems(page: number, count: number, around = 1): PageItem[] {
  const keep = new Set<number>([1, count]);
  for (let p = page - around; p <= page + around; p++) if (p >= 1 && p <= count) keep.add(p);
  const pages = [...keep].sort((a, b) => a - b);
  const out: PageItem[] = [];
  for (const p of pages) {
    const prev = out[out.length - 1];
    if (typeof prev === 'number' && p - prev === 2) out.push(prev + 1);
    else if (typeof prev === 'number' && p - prev > 2) out.push('gap');
    out.push(p);
  }
  return out;
}
